import { type ComponentType, Suspense, lazy } from "react";

// project imports
import MainLayout from "../layout/MainLayout";
import Loadable from "../ui-component/Loadable";
import AcknowledgementAdminRequest from "../views/pages/acknowledgementAdminRequest";
import Departments from "../views/pages/department";
import Designations from "../views/pages/designation";
import Document from "../views/pages/document";
import AddDocument from "../views/pages/document/AddDocument";
import ReuploadDocument from "../views/pages/document/ReuploadDocument";
import AddInternalApp from "../views/pages/internalApplication/AddInternalApp";
import DocumentRequestForMe from "../views/pages/RequestForMe";
import EmployeeDetails from "../views/pages/employeeDetails";
import AddPublicCalendar from "../views/configurations";
import AllEmployee from "../views/pages/allEmployee";
import MoodMonitor from "../views/pages/moodMonitor";
import AddMoodEmoji from "../views/pages/moodMonitor/AddMoodEmoji";
import InternalApplication from "../views/pages/internalApplication";
import AdminAccess from "../utils/AdminAccess";
import TicketPage from "@/views/pages/tickets";
import { Outlet } from "react-router-dom";
import { type SvgIconProps } from "@mui/material";

// dashboard routing
const DashboardDefault = Loadable(lazy(async () => await import("../views/dashboard/Default")));
const EmployeeDocumentAcknowledgements = Loadable(
  lazy(async () => await import("../views/pages/document/EmployeeDocumentAcknowledgements"))
);

// ==============================|| MAIN ROUTING ||============================== //

export interface childRouteType {
  breadcrumbs?: boolean;
  guardName: string;
  icon: ComponentType<SvgIconProps>;
  id: string;
  title: string;
  type: string;
  url: string;
}

export interface routeType {
  children: childRouteType[];
  id: string;
  title: string;
  type: string;
}

const adminRoutes = [
  {
    path: "internal-application",
    element: (
      <AdminAccess requiredRoles="admin">
        <InternalApplication />
      </AdminAccess>
    )
  },
  {
    path: "add-internal-application",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddInternalApp />
      </AdminAccess>
    )
  },
  {
    path: "add-internal-application/:id",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddInternalApp />
      </AdminAccess>
    )
  },
  {
    path: "mood-monitor",
    element: (
      <AdminAccess requiredRoles="admin">
        <MoodMonitor />
      </AdminAccess>
    )
  },
  {
    path: "add-mood-emoji",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddMoodEmoji />
      </AdminAccess>
    )
  },
  {
    path: "add-mood-emoji/:id",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddMoodEmoji />
      </AdminAccess>
    )
  },
  {
    path: "document",
    element: (
      <AdminAccess requiredRoles="admin">
        <Document />
      </AdminAccess>
    )
  },
  {
    path: "add-document",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddDocument />
      </AdminAccess>
    )
  },
  {
    path: "reupload-document",
    element: (
      <AdminAccess requiredRoles="admin">
        <ReuploadDocument />
      </AdminAccess>
    )
  },
  {
    path: "acknowledgement-request",
    element: (
      <AdminAccess requiredRoles="admin">
        <AcknowledgementAdminRequest />
      </AdminAccess>
    )
  },
  {
    path: "employee-document-acknowledgements",
    element: (
      <AdminAccess requiredRoles="admin">
        <EmployeeDocumentAcknowledgements />
      </AdminAccess>
    )
  }
];

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "",
      element: (
        <Suspense fallback="Loading...">
          <DashboardDefault />
        </Suspense>
      )
    },
    {
      path: "pages",
      children: [
        ...adminRoutes,
        {
          path: "all-employee",
          element: <AllEmployee />
        },
        {
          path: "tickets",
          element: <Outlet />,
          children: [
            {
              index: true,
              element: <TicketPage />
            }
          ]
        },
        {
          path: "document-acknowledgement-request-for-me",
          element: <DocumentRequestForMe />
        },
        {
          path: "departments",
          element: <Departments />
        },
        {
          path: "designations",
          element: <Designations />
        },
        {
          path: "employee-details",
          element: <EmployeeDetails />
        }
      ]
    },
    {
      path: "configurations",
      children: [
        {
          path: "public-calendar",
          element: (
            <Suspense fallback="Loading...">
              <AdminAccess requiredRoles="admin">
                <AddPublicCalendar />
              </AdminAccess>
            </Suspense>
          )
        }
      ]
    }
  ]
};

export default MainRoutes;
